import { BaseService, QueryParams } from "./BaseService";
import { OffersInput, OffersOutput } from "@/interfaces/offers";

export class OffersService extends BaseService<OffersInput, OffersOutput> {
  constructor() {
    super();
    this.path = "offers";
  }

  async findBySectionId(
    sectionId: string,
    queryParams?: QueryParams
  ): Promise<OffersOutput[]> {
    const url = `sections/${sectionId}/${this.path}`;
    const response = await this.request<OffersOutput[]>(url, {
      method: "GET",
      queryParams,
    });

    return response;
  }
}
